export default __webpack_public_path__ + "static/media/colon.90d9c002.svg";